export const customObjectsUsage = "/data_objects/data_objects_usage";
